import axios from './index'

class order {
    //回填
    static getOffLine(params) {
        return axios.post('/app-trains/order/offLine/success', params)
    }
    //驳回
    static reject(params) {
        return axios.post('/app-trains/order/offLine/reject', params)
    }
    //获取创建人列表
    static getCreateList(params) {
        return axios.get('/app-admin/express/bill/getUsers', { params: params })
    }
    //获取快递信息
    static getExpressMsg(id) {
        return axios.get(`/app-admin/express/bill/getExpressInfo/${id}`)
    }
    //获取机票单打印详情
    static getPlanePrint(params) {
        return axios.post('/app-admin/express/bill/trip/list', params)
    }
    //获取订单信息
    static getOrderMsg(params) {
        return axios.post('/app-admin/express/bill/task/list', params)
    }
    //order detail 
    static getPlaneOrder(params) {
        return axios.get('/app-admin/express/bill/trip/list', { params: params })
    }
    //获取订单列表
    static getOrderList(params) {
        return axios.get('/app-trains/order/search', { params: params })
    }
    //获取线下票台列表
    static getOffLineList(params) {
        return axios.get('/app-trains/order/searchOffLine', { params: params })
    }
    //获取车票状态列表
    static ticketStatusList(params) {
        return axios.get('/app-trains/order/status/page_list', { params: params })
    }

    //查询乘客车票状态
    static queryTicketStatus(params) {
        return axios.post('/app-trains/order/status/queryTicketStatus', params)
    }

    static getOrderDetail(code) {
        return axios.get(`/app-trains/order/detail/${code}`)
    }

    static orderConcel(params) {
        return axios.post(`/app-trains/order/cancel`, params)
    }


    //人工处理退票订单
    static handleRefundOrders(params) {
        return axios.post(`/app-trains/handle/handleRefundOrders`, params)
    }
    //人工处理占座和出票订单
    static handleOrders(params) {
        return axios.post(`/app-trains/handle/handleOrders`, params)
    }

    //获取供应订单列表
    static getPurchaseList(params) {
        return axios.get('/app-trains/purchase/search', { params: params })
    }

    //获取退票订单列表
    static getRefundList(params) {
        return axios.get('/app-trains/refund/page_list', { params: params })
    }

    //查看关联单
    static associated(params) {
        return axios.get('/app-trains/order/relation/orders', { params: params })
    }

    //查看退票单详情
    static refund(refundId) {
        return axios.get(`/app-trains/refund/info/${refundId}`)
    }

    //查看供应单详情    
    static purchase(purchase) {
        return axios.get(`/app-trains/purchase/detail/${purchase}`)
    }

    //供应单回填单号    
    static fill(params) {
        return axios.post(`/app-trains/purchase/fill`, params)
    }

    //查询供应单数量
    static purchaseCount(params) {
        return axios.get(`/app-trains/purchase/count`, { params: params })
    }

    //查询订单数量
    static orderCount(params) {
        return axios.get(`/app-trains/order/count`, { params: params })
    }

    //查询退票订单数量
    static refundCount(params) {
        return axios.get(`/app-trains/refund/totals`, { params: params })
    }




    //查询保险列表
    static insurance(params) {
        return axios.get(`/app-insurance/policy/getPageList`, { params: params })
    }

    //重新投保
    static reInsurance(params) {
        return axios.get(`/app-insurance/policy/saveInsuranceAgain/${params.serialNumber}`)
    }

    //重新退保
    static returnInsuranceAgain(params) {
        return axios.get(`/app-insurance/policy/returnInsuranceAgain/${params.serialNumber}`)
    }


    //积分用户查询
    static userScore(params) {
        return axios.get(`/app-admin/point/user/list`, { params: params })
    }
    //积分列表
    static scoreList(params) {
        return axios.get('/app-admin/point/order/list', { params: params })
    }

    //积分订单录入
    static addScoreOrder(params) {
        return axios.post('/app-admin/point/admin/preOrder', params)
    }
    //更新订单状态
    static updateOrderType(params) {
        return axios.post('/app-admin/point/order/update', params)
    }
    //导出
    static exports(params) {
        return axios.get('/app-admin/point/download', { params: params })
    }
    //上传
    static createBill(params) {
        return axios.post(`/app-admin/point/manually/create`, params, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
    }

    // 上传线下票台订单
    static createOffLine(params) {
        return axios.post(`/app-admin/offLineOrder/manually/create`, params, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
    }


}

export default order;
